// extracted by mini-css-extract-plugin
module.exports = {"zalo-share-btn":"zalo-share-btn"};